export default "__VITE_ASSET__BrG$GAOq__"